import CreateCourse from './CreateCourse.vue'

export default CreateCourse



// WEBPACK FOOTER //
// ./client/masteradmin/pages/CreateCourse/index.js